import React from "react"
import "./styles.scss"

const getButtonClasses = (variant = "default", size = "default", className = "") => {
  let classes = "button"
  classes += ` button--${variant}`
  classes += ` button--${size}`
  if (className) classes += ` ${className}`
  return classes
}

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={getButtonClasses(variant, size, className)}
        ref={ref}
        {...props}
      />
    )
  },
)

Button.displayName = "Button"

export { Button }
